import { defineMessages } from 'react-intl'

export const homeLicensingMessages = defineMessages({
  licenseCode: {
    id: 'homeLicensingMessages.licenseCode',
    description: "Column label for Licenses table showing licenses' codes",
    defaultMessage: 'License Code',
  },
  license: {
    id: 'homeLicensingMessages.license',
    description: 'Column label for Licenses table showing license',
    defaultMessage: 'License',
  },
  orderNumber: {
    id: 'homeLicensingMessages.orderNumber',
    description: 'Column label for Licenses table showing order number',
    defaultMessage: 'Order Number',
  },
  purchaseOrder: {
    id: 'homeLicensingMessages.purchaseOrder',
    description: 'Column label for Licenses table showing purchace order',
    defaultMessage: 'Purchase Order',
  },
  activated: {
    id: 'homeLicensingMessages.activated',
    description: 'Column label for Licenses table showing activated date',
    defaultMessage: 'Activated',
  },
  ends: {
    id: 'homeLicensingMessages.ends',
    description: 'Column label for Licenses table showing expiration date',
    defaultMessage: 'Ends',
  },
  notes: {
    id: 'homeLicensingMessages.notes',
    description: 'Column label for Licenses table showing notes',
    defaultMessage: 'Notes',
  },
  name: {
    id: 'homeLicensingMessages.name',
    description: 'Column label for Licenses table showing name of license',
    defaultMessage: 'Name',
  },
  noLicensesAppplied: {
    id: 'homeLicensingMessages.noLicensesAppplied',
    description:
      'Information message that no license files were applied for this home',
    defaultMessage: 'No Licenses Applied',
  },
  appliedLicenses: {
    id: 'homeLicensingMessages.appliedLicenses',
    description: 'Applied Licenses table title on Licensing page',
    defaultMessage: 'Applied Licenses',
  },
  created: {
    id: 'homeLicensingMessages.created',
    description: 'Column label for Licenses table showing created time',
    defaultMessage: 'Created',
  },
})
